import { createSelector } from 'reselect';
import store from 'src/store';

export const getData = (state) => state.userRight || {};


export const selectAllGroupsRight = createSelector(
  getData,
  ({ allGroupRights }) => allGroupRights
);

export const selectSelectedUserRightGroup = createSelector(
  getData,
  ({ selectedUserRightGroup }) => selectedUserRightGroup
);

export const selectUserRightsOptions = createSelector(
  getData,
  ({ options }) => options
);

export const selectFetching = createSelector(
  getData,
  ({ fetching }) => fetching
);

export const selectDefaultRights = createSelector(
  getData,
  ({ defaultRights }) => defaultRights
);

export const selectUserViewLevel = createSelector(
  (state) => state,
  (storeState) => {
    const userViewLevels = storeState?.userInfo?.data?.UserGroupWithRights?.Rights?.SelectWithValue[0]?.Flags || {};
    return Object.keys(userViewLevels).find((levelKey) => userViewLevels[levelKey]);
  }
);
